import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const browseStandardFlowsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-virtualagent-standard-flows',
	exact: true,
	path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/standard-flows',
};
